// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/happypack/loader.js?id=1!./~/happypack/loader.js?id=2!./~/sass-resources-loader/lib/loader.js?{"resources":["./app/scss/settings/params.scss","./app/scss/settings/mixins.scss"]}!./~/vue-loader/lib/style-compiler?{"id":"data-v-596bbb06","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/elements/K1Element.vue
// module id = 545
// module chunks = 0